import { render, staticRenderFns } from "./ProductsOverviewMedia.vue?vue&type=template&id=426b4ece&scoped=true&"
import script from "./ProductsOverviewMedia.vue?vue&type=script&lang=js&"
export * from "./ProductsOverviewMedia.vue?vue&type=script&lang=js&"
import style0 from "./ProductsOverviewMedia.vue?vue&type=style&index=0&id=426b4ece&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "426b4ece",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Button: require('/app/appsumo/nuxt/components/wishlists/Button.vue').default})
